import { render, staticRenderFns } from "./ProductsReportFilter.vue?vue&type=template&id=28990530"
import script from "./ProductsReportFilter.vue?vue&type=script&lang=js"
export * from "./ProductsReportFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports